import Modal from "components/atom/Modal.tsx";
import Button from "components/atom/button/Button.tsx";
import designerPng from "assets/images/designer.png";
import { useTranslation } from "react-i18next";
import { USER_PLAN_TYPES } from "globals/constants.ts";
import { EnumPlanType } from "globals/types/globals.ts";

function PlanChangedModal(props: {
  isOpen: boolean,
  onClose: () => void,
  onAccept: () => void,
  plan: EnumPlanType | null,
  currentPlan: EnumPlanType | null
}) {
  const { onClose, onAccept, isOpen, plan, currentPlan } = props;
  const { t } = useTranslation();

  if (!isOpen) {
    return null;
  }

  //go from complete to unit or canceled
  const showDeleteEventsWarning = ([
    USER_PLAN_TYPES.COMPLETE_MONTHLY,
    USER_PLAN_TYPES.COMPLETE_YEARLY,
    USER_PLAN_TYPES.FREE_COMPLETE
  ] as string[]).includes(currentPlan as string) && ([
    USER_PLAN_TYPES.UNIT,
    USER_PLAN_TYPES.CANCELED
  ] as string[]).includes(plan as string);

  //
  return (
    <Modal flexibleHeight className="-plan-changed" onClose={onClose}>
      <div className="w-full">
        <img src={designerPng} className="mx-auto block h-[200px] w-auto" />
        <h2 className="text-2xl pb-3 text-center font-semibold">
          {showDeleteEventsWarning ? (
            <span dangerouslySetInnerHTML={{ __html: t(`popup.cancelCompletePlan.title`) }} />
          ) : (
            <span>
              {t(`popup.planChanged.titles.${plan}`)}
            </span>
          )}
        </h2>
        <p className="pb-12 text-center text-gray-400">
          {showDeleteEventsWarning ? (
            <span dangerouslySetInnerHTML={{ __html: t(`popup.cancelCompletePlan.description`) }} />
          ) : (
            <span>
              {t(`popup.planChanged.descriptions.${plan}`)}
            </span>
          )}
        </p>

        <Button className="block w-full" onClick={onAccept}>
          {t("continue")}
        </Button>
      </div>
    </Modal>
  );
}


export default PlanChangedModal;
